import { useMutation } from '@tanstack/react-query';

import {
  apiClient,
  type ArtworkDetail,
  type LogoArtworkCreateAndUpdateWritable,
} from '@api';

/**
 * Creates a LOGO artwork via API.
 *
 * Required params: LogoArtworkCreateAndUpdateWritable payload (logo_text).
 * Important behavior: uses throwOnError=true and returns the created artwork detail.
 *
 * @example
 * const { mutateAsync } = useCreateLogoArtwork();
 * await mutateAsync({ logo_text: 'Anna' });
 */
export const useCreateLogoArtwork = (options: object = {}) => {
  return useMutation<ArtworkDetail, Error, LogoArtworkCreateAndUpdateWritable>({
    mutationFn: async (values) => {
      const response = await apiClient.artworksCreateLogoArtworkCreate<true>({
        body: values,
        throwOnError: true,
      });
      return response.data;
    },
    ...options,
  });
};
